export const AddressTypes = {
  MAILING_ADDRESS: 'mailingAddress',
  PHYSICAL_ADDRESS: 'physicalAddress',
};
